import { AppCriteria } from '../../types/decisions';

export const DEFAULT_PAGE_SIZE = 9;

export const initialHeaderLinks = [
    { label: 'Kaiser Permanente', link: 'https://kp.com' },
    { label: 'Sparkdit', link: 'https://www.sparkdit.com/' },
    { label: 'Terms of use', link: 'https://www.sparkdit.com/legal/terms-of-use' },
    // {label: 'Features', link: 'https://ai.sparkdit.com/webpages/view/1'},
    // {label: 'Support', link: 'https://ai.sparkdit.com/webpages/view/3'},
    // {label: 'Pricing', link: 'https://ai.sparkdit.com/webpages/view/4'},
];

export const allowedSkins = [ 'skin1', 'skin2', 'skin3', 'skin4', 'skin5', 'skin6', 'skin7' ];

export const initialAppCriteria: AppCriteria = {
    id: '',
    name: '',
    category: '',
    config: {
        skin: 'skin0',
        rerank_engine: '',
    },
    Dataset: null,
    Datasets: [],
    date_created: '',
    date_modified: '',
    run_count: '',
    description: '',
    fields: [],
    technoFields: [],
    icon: '',
    ranking: '',
    user_id: 0,
    visibility: '',
    disabled: false,
};